import type { GetTweetById200ReferencedTweetTweetBasicInfoAllOfTwoTweetType } from './getTweetById200ReferencedTweetTweetBasicInfoAllOfTwoTweetType';

export type GetTweetById200ReferencedTweetTweetBasicInfoAllOfTwo = {
  content?: string;
  /** 트윗 유형 */
  tweetType?: GetTweetById200ReferencedTweetTweetBasicInfoAllOfTwoTweetType;
};
